// removed by extract-text-webpack-plugin
module.exports = {"tabs":"_2HXQJgo4iztK2pNNz46YNZ","active":"_1HdPYi0s9EhepWu3mKmmXw","callInfo":"_1hz8V1LoVuDh6ZORisw-wf"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56efc063","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/meetings/meeting.less
// module id = Wpjz
// module chunks = 1